export type ActivityType = "logged" | "logged out"

export interface Metric {
  value: number
  color: string
  label: string
}

export interface UserActivity {
  activity: ActivityType
  username: string
  date: string
}

export const USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
  SUSPENDED: "suspended",
} as const

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS]

export type User = {
  id: string
  name: string
  email: string
  lastLogin: string
  location: string
  status: UserStatus
}
